if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseFloat(this.dataset.items);
      this.tabletItems = parseFloat(this.dataset.tabletItems);

      this.sliderInstance = false;

      this.updateMobileLinks();
      document.addEventListener("matchMobile", () => {
        this.updateMobileLinks();
        if (this.enableSlider) this.init();
      });
      document.addEventListener("unmatchMobile", () => {
        this.updateMobileLinks();
        if (this.enableSlider) this.init();
      });

      if (!this.enableSlider) return;

      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: this.tabletItems > 3 ? 3 : parseFloat(this.tabletItems),
        spaceBetween: columnGap.tablet,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          1024: {
            slidesPerView: parseFloat(this.items),
            spaceBetween: columnGap.tabletLarge
          },
          1280: {
            slidesPerView: parseFloat(this.items),
            spaceBetween: columnGap.desktop
          },
        },
        loop: this.dataset.loop !== 'false',
        threshold: 10,
        noSwiping: true,
        noSwipingSelector: '.product-card__swatches, .js-swatch-color',
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.target.closest('.product-card__swatches, .js-swatch-color')) {
              return;
            }

            const slide = element.closest('.swiper-slide');

            if (!slide) {
              return;
            }

            const slideRect = slide.getBoundingClientRect();
            const containerRect = this.getBoundingClientRect();
            const isFullyVisible =
              slideRect.left >= containerRect.left - 2 && slideRect.right <= containerRect.right + 2;

            if (isFullyVisible) {
              return;
            }

            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    updateMobileLinks() {
      const isMobile = FoxTheme.config.mqlMobile;
      this.querySelectorAll("a[data-url][data-url-mobile]").forEach((link) => {
        link.href = isMobile ? link.dataset.urlMobile : link.dataset.url;
      });
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('collection-list', CollectionList);
}
